document.documentElement.classList.remove('no-js');
document.addEventListener('DOMContentLoaded', function(){
  var toggle=document.querySelector('[data-mobile-toggle]');
  var nav=document.querySelector('[data-mobile-nav]');
  if(toggle&&nav){toggle.addEventListener('click',function(){nav.classList.toggle('is-open');toggle.setAttribute('aria-expanded',nav.classList.contains('is-open'));});}
  document.querySelectorAll('[data-problem-link]').forEach(function(el){el.addEventListener('click',function(){var target=document.querySelector(el.getAttribute('href'));if(target){target.scrollIntoView({behavior:'smooth'});}});});
  document.querySelectorAll('[data-variant-select]').forEach(function(select){
    var price=document.querySelector('[data-product-price]');
    function sync(){var option=select.options[select.selectedIndex]; if(price&&option){price.textContent=option.getAttribute('data-price')||price.textContent;}}
    select.addEventListener('change',sync); sync();
  });
  document.querySelectorAll('form.lead-capture').forEach(function(form){
    form.addEventListener('submit',function(){
      var tags=form.querySelector('[data-lead-tags]'); if(!tags){return;}
      var company=form.querySelector('[data-lead-company]'); var challenge=form.querySelector('[data-lead-challenge]');
      function clean(v){return (v||'').toLowerCase().replace(/[^a-z0-9]+/g,'-').replace(/^-+|-+$/g,'').slice(0,48);}
      var list=['newsletter','solutions lead','model health check'];
      if(company&&company.value){list.push('company-'+clean(company.value));}
      if(challenge&&challenge.value){list.push('need-'+clean(challenge.value));}
      tags.value=list.join(', ');
    });
  });
});